import { c as _c } from "react/compiler-runtime";
import { MenuItem } from "@/types/ui";
import { MoreHorizontal } from "lucide-react";
import React from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@components/ui/dropdown-menu";
import { SidebarMenuAction, SidebarMenuButton, SidebarMenuItem, SidebarMenuSubButton, SidebarMenuSubItem } from "@components/ui/sidebar";
import { cn } from "@lib/utils";
export const AppSidebarItem = t0 => {
  const $ = _c(43);
  const {
    item,
    isMobile,
    isSubItem
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== isMobile || $[1] !== item.burgerItems || $[2] !== router) {
    t1 = () => {
      if (item.burgerItems?.length && item.burgerItems.length > 0) {
        return <DropdownMenu><DropdownMenuTrigger asChild={true}><SidebarMenuAction showOnHover={true}><MoreHorizontal /><span className="sr-only">More</span></SidebarMenuAction></DropdownMenuTrigger><DropdownMenuContent className="w-48 rounded-md" side={isMobile ? "bottom" : "right"} align={isMobile ? "end" : "start"}>{item.burgerItems.map(subItem => <DropdownMenuItem key={subItem.label} onClick={() => router.push(subItem.url)}>{subItem.icon && <subItem.icon className="text-muted-foreground" />}<span>{subItem.label}</span></DropdownMenuItem>)}</DropdownMenuContent></DropdownMenu>;
      }
      return null;
    };
    $[0] = isMobile;
    $[1] = item.burgerItems;
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const renderSubItems = t1;
  if (isSubItem) {
    const t2 = item.isActive;
    const t3 = !item.isDisabled;
    let t4;
    if ($[4] !== item.isDisabled || $[5] !== t3) {
      t4 = cn({
        "text-muted-foreground": item.isDisabled,
        "hover:bg-accent": t3
      });
      $[4] = item.isDisabled;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== item.icon || $[8] !== item.isDisabled) {
      t5 = item.icon && <item.icon className={cn({
        "!text-muted-foreground": item.isDisabled,
        "!hover:bg-accent": !item.isDisabled
      })} />;
      $[7] = item.icon;
      $[8] = item.isDisabled;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== item.label) {
      t6 = <span>{item.label}</span>;
      $[10] = item.label;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== item.url || $[13] !== t5 || $[14] !== t6) {
      t7 = <Link href={item.url}>{t5}{t6}</Link>;
      $[12] = item.url;
      $[13] = t5;
      $[14] = t6;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== item.isActive || $[17] !== t4 || $[18] !== t7) {
      t8 = <SidebarMenuSubButton asChild={true} isActive={t2} className={t4}>{t7}</SidebarMenuSubButton>;
      $[16] = item.isActive;
      $[17] = t4;
      $[18] = t7;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    let t9;
    if ($[20] !== renderSubItems) {
      t9 = renderSubItems();
      $[20] = renderSubItems;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    let t10;
    if ($[22] !== t8 || $[23] !== t9) {
      t10 = <SidebarMenuSubItem>{t8}{t9}</SidebarMenuSubItem>;
      $[22] = t8;
      $[23] = t9;
      $[24] = t10;
    } else {
      t10 = $[24];
    }
    return t10;
  }
  let t2;
  if ($[25] !== item.icon || $[26] !== item.isActive || $[27] !== item.isDisabled || $[28] !== item.isFullButton || $[29] !== item.label || $[30] !== item.url) {
    t2 = item.isFullButton && <SidebarMenuButton asChild={true} variant="outline" tooltip={item.label} className={cn("min-h-10 border", {
      "text-muted-foreground": item.isDisabled,
      "bg-accent hover:border-sidebar-primary/50 hover:bg-accent": !item.isDisabled,
      "border-sidebar-primary/50 bg-accent": item.isActive
    })} disabled={item.isDisabled}><Link href={item.url}>{item.icon && <item.icon />}<span>{item.label}</span></Link></SidebarMenuButton>;
    $[25] = item.icon;
    $[26] = item.isActive;
    $[27] = item.isDisabled;
    $[28] = item.isFullButton;
    $[29] = item.label;
    $[30] = item.url;
    $[31] = t2;
  } else {
    t2 = $[31];
  }
  let t3;
  if ($[32] !== item.icon || $[33] !== item.isActive || $[34] !== item.isDisabled || $[35] !== item.isFullButton || $[36] !== item.label || $[37] !== item.url || $[38] !== renderSubItems) {
    t3 = !item.isFullButton && <><SidebarMenuButton asChild={true} tooltip={item.label} isActive={item.isActive} disabled={item.isDisabled} className={cn({
        "text-muted-foreground": item.isDisabled,
        "hover:bg-accent": !item.isDisabled
      })}><Link href={item.url}>{item.icon && <item.icon />}<span>{item.label}</span></Link></SidebarMenuButton>{renderSubItems()}</>;
    $[32] = item.icon;
    $[33] = item.isActive;
    $[34] = item.isDisabled;
    $[35] = item.isFullButton;
    $[36] = item.label;
    $[37] = item.url;
    $[38] = renderSubItems;
    $[39] = t3;
  } else {
    t3 = $[39];
  }
  let t4;
  if ($[40] !== t2 || $[41] !== t3) {
    t4 = <SidebarMenuItem>{t2}{t3}</SidebarMenuItem>;
    $[40] = t2;
    $[41] = t3;
    $[42] = t4;
  } else {
    t4 = $[42];
  }
  return t4;
};